/**
 * Componente Button customizável para a aplicação.
 *
 * Este componente renderiza um botão estilizado que pode ter diferentes variantes
 * visuais e comportamentos de clique personalizados.
 *
 * @module Button
 */

import { ExtendedStyledButton } from './Button.Styles';

/**
 * Componente funcional que renderiza um botão estilizado.
 *
 * @param {Object} props - Propriedades do componente
 * @param {string} props.text - Texto a ser exibido no botão
 * @param {string} props.variant - Variante visual do botão (ex: 'primary', 'secondary', etc.)
 * @param {Function} [props.onClick=()=>{}] - Função de callback executada ao clicar no botão
 * @returns {JSX.Element} Componente de botão estilizado
 */
const Button = (props) => {
  const { text, variant, onClick = () => {} } = props;
  return (
    <ExtendedStyledButton variant={variant} onClick={onClick}>
      {text}
    </ExtendedStyledButton>
  );
};

export default Button;
